import Env from 'Env';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isAuthorised } from 'utilities/user-utilities';

const useFilteredRoutes = (routes) => {
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);
  const portalType = useSelector((state) => state.userStore.portalType);

  const isAdminPortal = Env.isAdminPortal();

  const [filteredRoutes, setFilteredRoutes] = useState([]);

  useEffect(() => {
    if (!routes) {
      return;
    }

    const routePortalType = isAdminPortal ? 'admin' : portalType;
  
    setFilteredRoutes(routes.map(route => {
      if (route.nav !== 'main' || !route.portalAccess.includes(routePortalType) || !isAuthorised(loggedInUser, assignedGrandfatherClientNumber, route.accessRoles)) {
        return null; // Exclude routes that are not for nav, don't match portal type or the user does not have access roles for
      }
  
      const filteredSubMenuItems = route.subMenuItems ? route.subMenuItems.filter(subRoute =>
        subRoute.nav === 'main' &&
        subRoute.portalAccess.includes(routePortalType) &&
        isAuthorised(loggedInUser, assignedGrandfatherClientNumber, subRoute.accessRoles)
      ) : [];
  
      // Update the subMenuItems property if it exists
      return {
        ...route,
        ...(filteredSubMenuItems.length > 0 && { subMenuItems: filteredSubMenuItems })
      };
    }).filter(Boolean)); // Remove null entries
  }, [routes, portalType, assignedGrandfatherClientNumber, loggedInUser]);

  return filteredRoutes;
};

export default useFilteredRoutes;